import WorkHero from './WorkHero';

export default WorkHero;
